import * as React from 'react';
import { EntityCombobox, type EntityLookupItem } from '../ui/EntityCombobox';
import { fetcher } from '../../lib/api-fetcher';

export interface UserPickerProps {
  value?: string;
  onChange: (value: string, item?: EntityLookupItem) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
}

export function UserPicker({
  value,
  onChange,
  placeholder = 'Select Staff / User...',
  disabled,
  className,
}: UserPickerProps) {
  const fetchUsers = React.useCallback(async (query: string): Promise<EntityLookupItem[]> => {
    try {
      const res = await fetcher.get<{ data?: Array<{ id: string; name?: string; email?: string; role?: string; status?: string }> }>(
        `/staff/v1/users?limit=30${query ? `&search=${encodeURIComponent(query)}` : ''}`
      );
      const list = res?.data || [];
      return list.map((u) => ({
        id: u.id,
        title: u.name || u.email || 'User',
        subtitle: u.email || undefined,
        badge: u.role || u.status,
      }));
      // allow-silent-catch: return empty list on search failure
    } catch {
      return [];
    }
  }, []);

  return (
    <EntityCombobox
      value={value}
      onChange={onChange}
      fetchItems={fetchUsers}
      placeholder={placeholder}
      searchPlaceholder="Search staff by name or email..."
      disabled={disabled}
      className={className}
    />
  );
}
